module.exports = __webpack_public_path__ + "img/1.824043a7.webp";